import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import UrlEncoder from '../../components/UrlEncoder';

const UrlEncode: React.FC = () => (
  <ToolLayout
    title="URL Encoder Decoder Online Free | AllTools"
    description="Encode and decode URLs and query parameters. Free online URL encoding tool."
    canonicalPath="/url-encoder"
  >
    <UrlEncoder />
  </ToolLayout>
);

export default UrlEncode;
